import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getCookieConsentValue } from 'react-cookie-consent';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies';
import GenericError from '../GenericError';
import AlertaCookie from '../AlertaCookie';
import useSSR from '../../../util/hooks/useSSR';
import useLocation from '../../../util/hooks/useLocation';

const LayoutWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function CookiesProvider({ children }) {
  const isSSR = useSSR();
  const location = useLocation();
  const cookieName = 'isCookiesGranted';
  const [isCookiesGranted, setIsCookiesGranted] = useState(() => getCookieConsentValue(cookieName) === 'true');

  if (isCookiesGranted) {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      integrations: [new BrowserTracing()],
      sampleRate: 1.0,
    });
    initializeAndTrack(location);
  }

  /**
   * Tratamento para funcionar o build, pois ele não tem acesso ao window
   * Evita o erro: "navigator" is not available during server side rendering
   * https://github.com/twilio/twilio-video.js/issues/1012
   */
  if (isSSR) {
    return null;
  }

  if (navigator.cookieEnabled) {
    return (
      <>
        {children}
        <AlertaCookie
          cookieName={cookieName}
          onAccept={() => setIsCookiesGranted(true)}
        />
      </>
    );
  }

  return (
    <LayoutWrapper>
      <GenericError imageSrc="https://storage.googleapis.com/static-files-4fdd9378-835d-40e4-b124-36699ae5cc08/seguros/feedback/cookies-warning.svg">
        <p>
          Verificamos que você desabilitou os cookies.
          <br />
          Habilite essa opção nas configurações do seu navegador para utilizar o sistema.
        </p>
      </GenericError>
    </LayoutWrapper>
  );
}

CookiesProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CookiesProvider;
